export function trimTime(date: Date): Date {
    return new Date(new Date(date?.getTime()).setHours(0,0,0,0));
}

export function addDays(date: Date, days: number): Date {
    let newDate = new Date(date?.getTime());
    newDate.setDate(date.getDate() + days)
    return newDate;
}

export function setCurrentTime(date: Date, setSeconds?:boolean ): Date {
    let newDate = new Date(date);
    const currentDate = new Date();
    newDate.setHours(currentDate.getHours(), currentDate.getMinutes())

    if (setSeconds) {
        newDate.setSeconds(currentDate.getSeconds());
    }
    return newDate;
}

export function formatTimeDiff(start: Date, end: Date): string {
    const ms = Math.abs(end.getTime() - start.getTime()); // difference in milliseconds
    const totalMinutes = Math.floor(ms / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours && minutes) return `${hours}h ${minutes}m`;
    if (hours) return `${hours}h`;
    return `${minutes}m`;
}

export function minutesDiff(start: Date, end: Date): number {
    const ms = Math.abs(end.getTime() - start.getTime()); // difference in milliseconds
    const totalMinutes = Math.floor(ms / (1000 * 60));

    return totalMinutes;
}

export function isValidDate(date: Date) {
    return date instanceof Date && !isNaN(date.getTime())
}